export class EmailVerificationModel {

  constructor(
    public userId: string,
    public code: string
  ) {  }
}
